import React, { Component } from "react";
import { BASE_API, AppToaster } from "../../utils/constants";
import {
	Card,
	Switch,
	Spinner,
	Button,
	InputGroup,
	FormGroup,
	Icon,
} from "@blueprintjs/core";
import UiDialog from "../../components-fm/UiDialog";
import UISelect from "../../components-fm/UISelect";
import "../../css/SuperAdminDashboard.scss";

class AdminAntrenori extends Component {
	state = {
		loading: false,
		editing: {},
		showAddDialog: false,
		errors: {},
		antrenor: "",
		antrenori: [],
		userToBeDeleted: '',
		antrenor: "",
		email: "",
		phone: "",
		addTeamToCoach: null,
		errors: {}

	};

	componentDidMount() {
		// this.getData();
	}



	isOpenPopupAddCoach = () => {
		this.setState((prev) => ({ showAddDialog: !prev.showAddDialog }));
	};

	handleAddAntrenor = async () => {
		this.setState({ loading: true })
		this.isOpenPopupAddCoach(); // Închide popup-ul
		const organizationId = this.props.organizationId;
		const teamId = this.state?.addTeamToCoach?.id || null;
		const role = 'coach';
		const { antrenor, email, phone } = this.state;

		console.log({ organizationId, teamId, antrenor, email, phone, role });

		try {
			const res = await fetch(`${BASE_API}/api/admin/users`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					name: antrenor,
					email,
					phone,
					role,
					organizationId,
					teamId,
				}),
			});

			const data = await res.json();

			if (res.ok && data.success) {
				AppToaster.show({ message: "Antrenor adăugat cu succes", intent: "success" });
				this.setState({ antrenor: "", email: "", phone: "", addTeamToCoach: null, loading: false });
				this.props.getData(); // reîncarcă lista
			} else {
				AppToaster.show({ message: data.error || "Eroare la salvare", intent: "danger" });
			}
		} catch (err) {
			AppToaster.show({ message: "Eroare la rețea", intent: "danger" });
		}
	};


	isFormValid = () => {
		const { antrenor, errors } = this.state;
		return antrenor && !errors.antrenor;
	};

	handleInputChange = (e) => {
		const { name, value } = e.target;
		const errors = { ...this.state.errors };

		if (name === "antrenor") {
			errors.antrenor = /^[a-zA-Z0-9 \-_]+$/.test(value)
				? ""
				: "Sunt permise doar litere, cifre, spații, _ și -.";
		}

		if (name === "email") {
			errors.email = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
				? ""
				: "Email invalid";
		}

		if (name === "phone") {
			errors.phone = /^[0-9 +()-]{7,15}$/.test(value)
				? ""
				: "Telefon invalid";
		}

		this.setState({ [name]: value, errors });
	};


	handleEdit = (id, field, value) => {
		this.setState((prevState) => ({
			editing: {
				...prevState.editing,
				[id]: {
					...prevState.editing[id],
					[field]: value,
				},
			},
		}));
	};

	handleSave = async (id, field) => {
		const newValue = this.state.editing[id]?.[field];
		if (newValue === undefined) return;

		try {
			const res = await fetch(`${BASE_API}/api/admin/antrenori/${id}`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ field, value: newValue }),
			});
			const data = await res.json();
			if (res.ok && data.success) {
				this.getData();
			} else {
				AppToaster.show({ message: data.error || "Eroare la salvare", intent: "danger" });
			}
		} catch {
			AppToaster.show({ message: "Eroare la rețea", intent: "danger" });
		}
	};

	confirmUserDrop = (user) => {
		console.log('--------------')
		this.setState((prev) => ({
            isConfirmUserDeleteOpen: !prev.isConfirmUserDeleteOpen,
            userToBeDeleted: user
        }));
	}

	dropUser = async () => {
		this.setState({ isConfirmUserDeleteOpen: false, userToBeDeleted: false });

		let userId = this.state.userToBeDeleted.id;
		if (!userId) {
			AppToaster.show({
				message: "Niciun utilizator selectat.",
				intent: "danger",
				timeout: 5000,
			});
			return;
		}

		try {
			const res = await fetch(`${BASE_API}/api/users/${userId}`, {
				method: 'DELETE'
			});
			const data = await res.json();
			if (res.ok) {
				AppToaster.show({
					message: "Utilizatorul a fost șters cu succes.",
					intent: "success",
					timeout: 5000,
				});

				// Reîncarcă lista de useri
				this.props.getData?.();
			} else {
				AppToaster.show({
					message: "Eroare: " + (data.error || "Nu s-a putut șterge utilizatorul."),
					intent: "danger",
					timeout: 5000,
				});
			}
		} catch (err) {
			console.error(err);
			AppToaster.show({
				message: "Eroare de rețea.",
				intent: "danger",
				timeout: 5000,
			});
		}

	}

	render() {
		const { coaches, teams } = this.props
		const {
			antrenor,
			loading,
			editing,
			showAddDialog,
			errors,
			addTeamToCoach,
			userToBeDeleted, 
			isConfirmUserDeleteOpen, 
			phone, 
			email
		} = this.state;
		console.log('State....', this.state)

		if (loading) return <Spinner />;
		console.log('PROPS....', this.props)
		return (
			<>
				<div className="admin-table-container">
					<div className="dashboard-header">
						<div className="header-actions">
							<Button
								className="seagreen btn-medium"
								onClick={this.isOpenPopupAddCoach}
							>
								Adaugă Antrenor
							</Button>
						</div>
					</div>

					{coaches.length ? (
						<table className="admin-table">
							<thead>
								<tr>
									<th>Nume</th>
									<th>Rol</th>
									<th>Echipa</th>
									<th>Telefon</th>
									<th>Email</th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								{coaches.map((u) => (
									<tr key={u.id}>
										<td>
											<InputGroup
												fill
												style={{ minWidth: "160px" }}
												value={editing[u.id]?.name ?? u.name ?? ""}
												onChange={(e) => this.handleEdit(u.id, "name", e.target.value)}
												onBlur={() => this.handleSave(u.id, "name")}
												onKeyDown={(e) => e.key === "Enter" && this.handleSave(u.id, "name")}
											/>
										</td>
										<td>{u.role}</td>
										<td>{u.TeamName}</td>
										{/* <td>{u.organization}</td> */}
										<td>{u.phone}</td>
										<td>
											<InputGroup
												fill
												style={{ minWidth: "160px" }}
												value={editing[u.id]?.email ?? u.email ?? ""}
												onChange={(e) => this.handleEdit(u.id, "email", e.target.value)}
												onBlur={() => this.handleSave(u.id, "email")}
												onKeyDown={(e) => e.key === "Enter" && this.handleSave(u.id, "email")}
											/>
										</td>
										<td onClick={() => this.confirmUserDrop({id: u.id, name: u.name})}><Icon icon='trash'/></td>
										{/* <td>{u.created_at?.split(" ")[0]}</td> */}
									</tr>
								))}
							</tbody>
						</table>
					) : null}
				</div>

				<UiDialog
					isOpen={showAddDialog}
					onClose={this.isOpenPopupAddCoach}
					title="Adaugă antrenor"
					footer={
						<>
							<Button className="alert-bordered btn-medium" onClick={this.isOpenPopupAddCoach}>
								Anulează
							</Button>
							<Button
								className="seagreen btn-medium"
								onClick={this.handleAddAntrenor}
								disabled={!this.isFormValid()}
							>
								Salvează
							</Button>
						</>
					}
				>
					<FormGroup label="Nume complet" intent={errors.antrenor ? "danger" : "none"} helperText={errors.antrenor}>
						<InputGroup
							name="antrenor"
							value={antrenor}
							onChange={this.handleInputChange}
							intent={errors.antrenor ? "danger" : "none"}
						/>
					</FormGroup>

					<FormGroup label="Email" intent={errors.email ? "danger" : "none"} helperText={errors.email}>
						<InputGroup
							name="email"
							type="email"
							value={email}
							onChange={this.handleInputChange}
							intent={errors.email ? "danger" : "none"}
						/>
					</FormGroup>

					<FormGroup label="Telefon" intent={errors.phone ? "danger" : "none"} helperText={errors.phone}>
						<InputGroup
							name="phone"
							value={phone}
							onChange={this.handleInputChange}
							intent={errors.phone ? "danger" : "none"}
						/>
					</FormGroup>

					<FormGroup label="Selectează echipă">
						<UISelect
							items={this.props?.teams?.map(t => ({ id: t.id, name: t.name }))}
							selectedItem={addTeamToCoach}
							onItemSelect={(team) => this.setState({ addTeamToCoach: team })}
							placeholder="Alege echipă..."
						// filterable={false}
						// popoverProps={{ usePortal: false }}
						/>
					</FormGroup>
				</UiDialog>
				
				{/* Drop users */}
				<UiDialog
					isOpen={isConfirmUserDeleteOpen}
					onClose={this.confirmUserDrop}
					title="Șterge organizație"
					footer={
						<>
							<Button className="alert-bordered btn-medium" onClick={this.confirmUserDrop}>Anulează</Button>
							<Button className="alert btn-medium" onClick={this.dropUser}>Șterge</Button>
						</>
					}
				>
					<div>
						Confirmi ștergerea userului <strong>{this.state.userToBeDeleted?.name}</strong>?
					</div>
				</UiDialog>

			</>
		);
	}
}

export default AdminAntrenori;
